module.exports = __webpack_public_path__ + "media/images/icon-foryou-2f9876e78baf9ec2d63034bad297bb41.svg";